import Axios from 'axios';
import { BASE_PATH } from '../constants/paths';
import storage from '../helpers/storage';
import { nameBasedRoutes } from 'router/public';



/**
 * Axios Interceptor
 * @param {*} config
 * @returns {*}
 */
function authRequestInterceptor(config: any) {
    const token = storage.getToken();
    if (token) {
        config.headers.authorization = `bearer ${token}`;
    }
    config.headers.Accept = 'application/json';
    return config;
}


/**
 * Axios Object to use 
 * @type {*}
 */
export const axios = Axios.create({
    baseURL: BASE_PATH,
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        //check status if 401 then logout
        if (error.response.status === 401) {
            localStorage.removeItem("SI_refreshToken");
            localStorage.removeItem("SI_token");
            localStorage.removeItem("user-info");
            const token = localStorage.getItem("SI_token");
            if(token){
                window.location.href =  nameBasedRoutes.login.path;
            }
            
            //redirect to login page withot refresh
            
    
            }
            return Promise.reject(error);
    }
);
